import { render, staticRenderFns } from "./Mailchimp.vue?vue&type=template&id=70203ffa"
import script from "./Mailchimp.vue?vue&type=script&lang=js"
export * from "./Mailchimp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports